import { saveAs } from 'file-saver'
import $http from '@/libs/axios'
import FormsService from '@/services/forms-service'

class TransactionsAPIs {
    private static fees: any = {};

    static async getPaymentMethodsFees(currency: string) {
      if (this.fees[currency]) {
        return this.fees[currency]
      }
      this.fees[currency] = (await $http.get(`/fees/${currency}`)).data
      return this.fees[currency]
    }

    static async exportExcel(branchId: any, filters: any, print = 0) {
      const url = `orders/transactions/list/${branchId}?${FormsService.prepareQueryString({ ...filters, export: true, print }, true)}`
      const file = (await $http.get(url, { responseType: 'blob' })).data
      if (!print) {
        saveAs(file, 'transactions.xlsx')
      }
      return file
    }

    static async printExcel(branchId: any, filters: any) {
      const file = await TransactionsAPIs.exportExcel(branchId, filters, 1)
      return URL.createObjectURL(file)
    }
}

export default TransactionsAPIs
